import {
    createVNode as _$cv,
    className as _$cn,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Button} from '../button';
import {Icon} from '../icon';
import {Input} from '../input';
import {getRestProps} from '../utils';
import {makeStyles} from './styles';

var _$tmp0 = {
    'className': 'k-spinner-icon ion-ios-minus-empty'
};
var _$tmp1 = {
    'className': 'k-spinner-icon ion-ios-arrow-down'
};
var _$tmp2 = {
    'className': 'k-spinner-icon ion-ios-plus-empty'
};
var _$tmp3 = {
    'className': 'k-spinner-icon ion-ios-arrow-up'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    const {className, disabled, size, vertical, value, width} = this.get();
    const classNameObj = {
        'k-spinner': true,
        'k-disabled': disabled,
        [`k-${size}`]: size !== 'default',
        [className]: className,
        'k-vertical': vertical,
        [makeStyles()]: true,
    };
    const {decrease, increase, changeValue, onFocusin} = this.change;
    
    return _$cv('div', {
        'className': _$cn(classNameObj),
        ...getRestProps(this)
    }, [
        _$cc(Button, {
            'icon': true,
            'ev-click': decrease,
            'disabled': this.isDisabledDecrease(),
            'className': 'k-spinner-btn k-left',
            'size': size,
            'children': (
                (!vertical) ?
                    _$cc(Icon, _$tmp0) :
                    _$cc(Icon, _$tmp1)
            )
        }),
        _$cc(Input, {
            'className': 'k-spinner-input',
            'disabled': disabled,
            'ev-change': changeValue,
            'ev-focusin': onFocusin,
            'value': this.value.showValue.value,
            'ev-input': this.onInput,
            'size': size,
            'width': width
        }),
        _$cc(Button, {
            'icon': true,
            'ev-click': increase,
            'disabled': this.isDisabledIncrease(),
            'className': 'k-spinner-btn k-right',
            'size': size,
            'children': (
                (!vertical) ?
                    _$cc(Icon, _$tmp2) :
                    _$cc(Icon, _$tmp3)
            )
        })
    ]);
};